<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101.37 104.53">
  <g style="isolation:isolate">
    <g id="edef894d-7cc8-4868-896b-352cc1dfd11f" data-name="Layer 2">
      <g id="bd2f45b0-e5c8-454b-83f9-80553a6b5428" data-name="klok">
        <g id="a9252929-600a-4e7a-8a24-dba0a9687df7" data-name="klok">
          <path
            d="M65.91,100.18C41.09,111.86,14.13,99.28,3,71.1-7,45.58,9.33,18.36,33.51,5.39,58.24-7.88,79.31,5,92.91,28.78,114.54,66.69,90.73,88.49,65.91,100.18Z"
            style="fill:#fff;opacity:0.5" />
          <path
            d="M14.08,77.63C-2,59,2.32,32.63,24,16.19,43.65,1.3,71.16,8.89,88.23,26.66c17.47,18.18,11.47,39.51-5.86,57C54.82,111.59,30.19,96.27,14.08,77.63Z"
            style="fill:#fff;opacity:0.73" />
          <path
            d="M75.13,24.18,77.26,20l2.62,1.33a3.35,3.35,0,0,0,4.51-1.47l1-2.08A3.34,3.34,0,0,0,84,13.26L67,4.67a3.34,3.34,0,0,0-4.5,1.47L61.47,8.22a3.34,3.34,0,0,0,1.47,4.5l2.63,1.34-2.13,4.2a39.16,39.16,0,1,0,11.69,5.92Z"
            style="fill:#b3b3b3;mix-blend-mode:multiply;opacity:0.53" />
          <circle cx="48.25" cy="53.23" r="39.7" style="fill:#ffbc00" />
          <path d="M86.71,43.43A39.69,39.69,0,0,1,9,59.37,39.69,39.69,0,1,0,86.71,43.43Z"
            style="fill:#ffbc00;mix-blend-mode:multiply;opacity:0.44" />
          <circle cx="47.19" cy="51.93" r="33.03" style="fill:#ffd55e" />
          <circle cx="48.25" cy="53.23" r="32.19" style="fill:#fff" />
          <path d="M80.43,53.42a32.18,32.18,0,0,0-32-32.37l-.19,32.18Z" style="fill:#d95f08" />
          <path d="M70.06,29.56a32.1,32.1,0,0,0-21.62-8.51l-.19,32.18Z" style="fill:#c21919" />
          <rect x="55.93" y="11.61" width="13.28" height="8.18" transform="translate(9.71 -21.27) rotate(20.88)"
            style="fill:#ffbc00" />
          <polygon points="69.22 16.88 57.34 10.77 57.82 9.52 70.22 14.25 69.22 16.88"
            style="fill:#ffbc00;mix-blend-mode:multiply;opacity:0.52" />
          <rect x="52.51" y="3.35" width="26.04" height="9.15" rx="3.4" transform="translate(7.13 -22.84) rotate(20.88)"
            style="fill:#ffbc00" />
          <line x1="56.11" y1="0.54" x2="53.63" y2="7.06"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="58.06" y1="1.28" x2="55.57" y2="7.8"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="60" y1="2.02" x2="57.51" y2="8.54"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="61.94" y1="2.76" x2="59.45" y2="9.28"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="63.88" y1="3.5" x2="61.4" y2="10.02"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="65.82" y1="4.25" x2="63.34" y2="10.76"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="67.77" y1="4.99" x2="65.28" y2="11.5"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="69.71" y1="5.73" x2="67.22" y2="12.24"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="71.65" y1="6.47" x2="69.17" y2="12.98"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="73.59" y1="7.21" x2="71.11" y2="13.72"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="75.54" y1="7.95" x2="73.05" y2="14.47"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <line x1="77.48" y1="8.69" x2="74.99" y2="15.21"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.603512153220731px" />
          <polygon points="48.23 24.68 45.89 18.55 50.54 18.55 48.23 24.68"
            style="fill:#273659;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px" />
          <polygon points="48.23 24.68 45.89 18.55 50.54 18.55 48.23 24.68"
            style="fill:#273659;stroke:#273659;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.775544306442645px" />
        </g>
        <g id="fc268496-45af-4308-82ee-9f87ed39cd0d" data-name="wijzer_bg">
          <circle cx="48.26" cy="53.15" r="28.1" style="fill:#fff" />
        </g>
        <g id="fad1bf7e-0fd4-4ac3-a277-e50dabb757bc" data-name="klok_wijzer" [ngStyle]="clockStyle">
          <circle cx="48.26" cy="53.15" r="2.95"
            style="fill:none;stroke:#d95f08;stroke-miterlimit:10;stroke-width:1.81053645966219px" />
          <circle cx="48.26" cy="64.55" r="2.15" style="fill:#d95f08" />
          <line x1="48.26" y1="55.92" x2="48.26" y2="64.55"
            style="fill:none;stroke:#d95f08;stroke-miterlimit:10;stroke-width:1.20702430644146px" />
          <line x1="48.26" y1="50.28" x2="48.27" y2="26.46"
            style="fill:none;stroke:#d95f08;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.20702430644146px" />
        </g>
      </g>
    </g>
  </g>
</svg>
